import { useQueryClient } from '@tanstack/react-query'

export const usePrefetch = (params: Parameters<ReturnType<typeof useQueryClient>['prefetchQuery']>[number]) => {
  const queryClient = useQueryClient()
  const prefetch = async () => {
    await queryClient.prefetchQuery(params)
  }

  return prefetch
}
